import gql from 'graphql-tag'

export default gql`
query getPointsSystem {
	cashAssist {
		getAppConfig {
			cashRegisterGlobal {
				pointsSystemName
				isActivePointsSystem
			}
		}
	}
}`
